import { useTranslation } from 'react-i18next';
import { ExpenseIllustration } from '../../../../app/assets/icons/tutorial';
import { Line } from '../../../common/components/fragments';
import { CommonTutorial } from './CommonTutorial';
import { TutorialText, TutorialTitle } from './components';

const ExpenseTutorialText = () => {
  const { t } = useTranslation();
  return (
    <>
      <Line />
      <TutorialTitle className="mt-[14px]">
        {t('front.payslip.tdc.expense.tutorial.title')}
      </TutorialTitle>
      <TutorialText>
        {t('front.payslip.tdc.expense.tutorial.text')}
      </TutorialText>
    </>
  );
};

export const ExpenseTutorial = ({ onClick }: { onClick: () => void }) => (
  <CommonTutorial
    Icon={<ExpenseIllustration height={203} width={178} />}
    onClick={onClick}
    Component={<ExpenseTutorialText />}
  />
);
